const patternBookingToast = (state = null, action) => {
  if (action.type === "SET_PATTERN_BOOKING_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_PATTERN_BOOKING_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default patternBookingToast;
